import PhotoCounterField from './PhotoCounterField';

export default PhotoCounterField;
